import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var IListOrdersByBrandOrderResponse;
(function (IListOrdersByBrandOrderResponse) {
  var RetailerIdvStatus;
  (function (RetailerIdvStatus) {
    /**
     * Unknown status.
     */
    RetailerIdvStatus["RETAILER_IDV_STATUS_UNKNOWN"] = "RETAILER_IDV_STATUS_UNKNOWN";
    /**
     * The retailer has never received any IDV request.
     */
    RetailerIdvStatus["NEVER_RECEIVED_IDV"] = "NEVER_RECEIVED_IDV";
    /**
     * There is an pending IDV request waiting for the retailer's response.
     */
    RetailerIdvStatus["HAS_PENDING_IDV_REQUEST"] = "HAS_PENDING_IDV_REQUEST";
    /**
     * The retailer has responded all IDV requests.
     */
    RetailerIdvStatus["IDV_REQUEST_RESPONDED"] = "IDV_REQUEST_RESPONDED";
  })(RetailerIdvStatus = IListOrdersByBrandOrderResponse.RetailerIdvStatus || (IListOrdersByBrandOrderResponse.RetailerIdvStatus = {}));
  var IBrandOrderData;
  (function (IBrandOrderData) {
    var IBrandData;
    (function (IBrandData) {
      /**
       * Return an instance of IBrandData with the provided fields. Any field not
       * listed will be populated with an empty value (an empty array,
       * or undefined, whichever is valid for the type of the value.)
       */
      IBrandData.build = function (partial) {
        return _objectSpread({}, partial !== null && partial !== void 0 ? partial : {});
      };
    })(IBrandData = IBrandOrderData.IBrandData || (IBrandOrderData.IBrandData = {}));
    var IItemData;
    (function (IItemData) {
      /**
       * Return an instance of IItemData with the provided fields. Any field not
       * listed will be populated with an empty value (an empty array,
       * or undefined, whichever is valid for the type of the value.)
       */
      IItemData.build = function (partial) {
        return _objectSpread({}, partial !== null && partial !== void 0 ? partial : {});
      };
    })(IItemData = IBrandOrderData.IItemData || (IBrandOrderData.IItemData = {}));
    var IBrandReviewData;
    (function (IBrandReviewData) {
      /**
       * Return an instance of IBrandReviewData with the provided fields. Any field not
       * listed will be populated with an empty value (an empty array,
       * or undefined, whichever is valid for the type of the value.)
       */
      IBrandReviewData.build = function (partial) {
        return _objectSpread({}, partial !== null && partial !== void 0 ? partial : {});
      };
    })(IBrandReviewData = IBrandOrderData.IBrandReviewData || (IBrandOrderData.IBrandReviewData = {}));
    var IEligibility;
    (function (IEligibility) {
      var Enum;
      (function (Enum) {
        /**
         * Should not be used.
         * TODO(noah): change this to UNKNOWN once Faire/backend#58586 lands before we launch
         */
        Enum["ENUM_UNKNOWN"] = "ENUM_UNKNOWN";
        /**
         * Not eligible for this action
         */
        Enum["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
        /**
         * Eligible for this action without any issues
         */
        Enum["ELIGIBLE"] = "ELIGIBLE";
        /**
         * Requires someone to review and process the eligibility of this action
         */
        Enum["MANUAL_PROCESS_REQUIRED"] = "MANUAL_PROCESS_REQUIRED";
      })(Enum = IEligibility.Enum || (IEligibility.Enum = {}));
      /**
       * Return an instance of IEligibility with the provided fields. Any field not
       * listed will be populated with an empty value (an empty array,
       * or undefined, whichever is valid for the type of the value.)
       */
      IEligibility.build = function (partial) {
        return _objectSpread({}, partial !== null && partial !== void 0 ? partial : {});
      };
    })(IEligibility = IBrandOrderData.IEligibility || (IBrandOrderData.IEligibility = {}));
    var IShipmentData;
    (function (IShipmentData) {
      var IShipmentStatus;
      (function (IShipmentStatus) {
        /**
         * Return an instance of IShipmentStatus with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IShipmentStatus.build = function (partial) {
          return _objectSpread({}, partial !== null && partial !== void 0 ? partial : {});
        };
      })(IShipmentStatus = IShipmentData.IShipmentStatus || (IShipmentData.IShipmentStatus = {}));
      /**
       * Return an instance of IShipmentData with the provided fields. Any field not
       * listed will be populated with an empty value (an empty array,
       * or undefined, whichever is valid for the type of the value.)
       */
      IShipmentData.build = function (partial) {
        return _objectSpread({}, partial !== null && partial !== void 0 ? partial : {});
      };
    })(IShipmentData = IBrandOrderData.IShipmentData || (IBrandOrderData.IShipmentData = {}));
    /**
     * Return an instance of IBrandOrderData with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IBrandOrderData.build = function (partial) {
      return _objectSpread({
        items: [],
        shipment_data: []
      }, partial !== null && partial !== void 0 ? partial : {});
    };
  })(IBrandOrderData = IListOrdersByBrandOrderResponse.IBrandOrderData || (IListOrdersByBrandOrderResponse.IBrandOrderData = {}));
  /**
   * Return an instance of IListOrdersByBrandOrderResponse with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  IListOrdersByBrandOrderResponse.build = function (partial) {
    return _objectSpread({
      filter_sections: [],
      orders: []
    }, partial !== null && partial !== void 0 ? partial : {});
  };
})(IListOrdersByBrandOrderResponse || (IListOrdersByBrandOrderResponse = {}));